import { render, staticRenderFns } from "./BuyVipEntrance.vue?vue&type=template&id=334a9bf0&scoped=true&"
import script from "./BuyVipEntrance.vue?vue&type=script&lang=ts&"
export * from "./BuyVipEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./BuyVipEntrance.vue?vue&type=style&index=0&id=334a9bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334a9bf0",
  null
  
)

export default component.exports